import { useField } from '@arc/frontend/util-common';
import { InputTextFieldLength } from './InputTextFieldLength';
/**
 * Input with helper text displaying current length of the input value.
 * Sets error when length is past the max length
 * NOTE: String max length must also be set on form schema
 */
export function InputTextFieldLengthWithControl(props) {
  const {
    name,
    ...other
  } = props;
  const {
    field: {
      ref,
      ...inputProps
    },
    fieldState: {
      invalid: error
    },
    errorMessage
  } = useField({
    name,
    maxLength: other.maxLength
  });
  return <InputTextFieldLength {...inputProps} inputRef={ref} error={error} helperText={errorMessage} {...other} />;
}